const scrollToSection = (hash) => {
  if (window.__lenis) {
    window.__lenis.scrollTo(hash, { offset: -72 });
  } else {
    document.querySelector(hash)?.scrollIntoView({ behavior: "smooth" });
  }
};

export default function LandingHeader() {
  return (
    <header
      data-testid="site-header"
      className="fixed inset-x-0 top-0 z-50 border-b border-[#D4AF37]/20 bg-[#0D0D0D]/80 backdrop-blur-xl"
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4">
        <button
          type="button"
          onClick={() => scrollToSection("#hero")}
          data-testid="header-logo"
          className="flex items-center gap-3"
        >
          <span className="flex h-9 w-9 items-center justify-center rounded-full border border-[#D4AF37] font-serif-lux text-sm text-[#D4AF37]">
            JF
          </span>
          <span className="font-serif-lux text-base tracking-[0.25em] text-white sm:text-lg">
            CORTISOLO <span className="text-[#D4AF37]">ZERO</span>
          </span>
        </button>
        <nav className="hidden items-center gap-10 md:flex" data-testid="header-nav">
          <button
            type="button"
            onClick={() => scrollToSection("#il-metodo")}
            data-testid="header-nav-metodo"
            className="text-xs font-medium uppercase tracking-[0.2em] text-[#A3A3A3] transition-colors duration-300 hover:text-[#D4AF37]"
          >
            Il Metodo
          </button>
          <button
            type="button"
            onClick={() => scrollToSection("#candidatura")}
            data-testid="header-nav-candidatura"
            className="text-xs font-medium uppercase tracking-[0.2em] text-[#A3A3A3] transition-colors duration-300 hover:text-[#D4AF37]"
          >
            Mentorship
          </button>
        </nav>
        <a
          href="https://amazon.com/dp/B0HKFF979L"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="header-amazon-cta"
          className="border border-[#B87333] bg-[#B87333] px-5 py-2.5 text-xs font-bold uppercase tracking-[0.15em] text-white transition-colors duration-300 hover:bg-[#D2853D] hover:shadow-[0_0_24px_rgba(184,115,51,0.35)]"
        >
          Acquista Manuale
        </a>
      </div>
    </header>
  );
}
